import FlyBlankSlateComponent from '@customerio/fly-components/components/fly-blankslate';

export default FlyBlankSlateComponent;
